import { ExternalConnection } from '@griply/types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Colors } from 'shared/components/ui/alert';

import * as Styled from './calendar-reconnect-notice.style';
import { CalendarReconnectRow } from './calendar-reconnect-row';

export type CalendarReconnectNoticeProps = {
  connections: ExternalConnection[];
};

export const CalendarReconnectNotice: React.FC<
  CalendarReconnectNoticeProps
> = ({ connections }) => {
  const { t } = useTranslation();

  if (!connections.length) {
    return null;
  }

  return (
    <Alert color={Colors.Warning}>
      <Styled.Content>
        <Styled.Message>
          {t('calendar.sync-tasks.reconnect-notice')}
        </Styled.Message>

        <Styled.List>
          {connections.map((connection) => (
            <CalendarReconnectRow key={connection.id} connection={connection} />
          ))}
        </Styled.List>
      </Styled.Content>
    </Alert>
  );
};
